interface Props {
    onClick: () => void
    disabled?: boolean
}

const DeleteButton = (props: Props) => {
    return <button
        onClick={props.onClick}
        disabled={props.disabled}
        className="px-3 py-1 text-sm bg-red-300 text-white rounded hover:bg-red-600 disabled:opacity-50"
    >❌</button>
}

export default DeleteButton